module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10240.e3c2a412.jpg";